/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, monthly: NonNullable<unknown> }} Shareofferlimits2Inputs */

const en_shareofferlimits2 = /** @type {(inputs: Shareofferlimits2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Until ${i?.date} or while the pool lasts, at most ${i?.monthly} credits a month.`)
};

const de_shareofferlimits2 = /** @type {(inputs: Shareofferlimits2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bis ${i?.date} oder solange der Vorrat reicht, höchstens ${i?.monthly} Credits im Monat.`)
};

/**
* | output |
* | --- |
* | "Until {date} or while the pool lasts, at most {monthly} credits a month." |
*
* @param {Shareofferlimits2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const shareofferlimits2 = /** @type {((inputs: Shareofferlimits2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shareofferlimits2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shareofferlimits2(inputs)
	return de_shareofferlimits2(inputs)
});
export { shareofferlimits2 as "shareOfferLimits" }